export default __webpack_public_path__ + "static/feature-discovery-bitbucket-c5acfff717c039463ef96e5b3f05996d.png";